import { format, isAfter, isBefore, parseISO } from 'date-fns'
import type { NonHomeownerUser, VolunteerTableRow } from '@/features/volunteers/types/volunteers.type'

function parseServeDate(val: string | Date | undefined): Date | null {
  if (!val) return null
  if (val instanceof Date) return isNaN(val.getTime()) ? null : val
  if (typeof val === 'string') {
    const d = /^\d{4}-\d{2}-\d{2}/.test(val) ? parseISO(val.split('T')[0]) : parseISO(val)
    return isNaN(d.getTime()) ? null : d
  }
  return null
}

export type ArLeadershipEvent = {
  userId: number
  fullname: string
  from: Date
  to: Date
}

/** Same rules as Ar Team calendar: base leaders / admins with serveDates for this region */
export function extractArLeadershipEvents(
  users: (NonHomeownerUser | VolunteerTableRow)[],
  regionId: number | undefined | null
): ArLeadershipEvent[] {
  const events: ArLeadershipEvent[] = []
  for (const user of users) {
    const serveDates = user.volunteer?.serveDates
    if (!serveDates || !Array.isArray(serveDates)) continue
    const fullname = user.fullname || 'Unknown'

    for (const period of serveDates) {
      if (regionId != null && regionId > 0) {
        const p = period as { from?: string; to?: string; regionId?: number }
        let periodRegionId: number | null = null
        if (p.regionId != null) {
          periodRegionId = typeof p.regionId === 'number' ? p.regionId : parseInt(String(p.regionId), 10)
          if (isNaN(periodRegionId)) periodRegionId = null
        }
        if (periodRegionId !== regionId) continue
      }
      const from = parseServeDate(period.from)
      const to = parseServeDate(period.to)
      if (!from || !to || from > to) continue
      events.push({ userId: user.id, fullname, from, to })
    }
  }
  return events
}

/** Count distinct AR leadership date ranges active on this calendar day (matches AR Team day cell logic). */
export function countArLeadershipOnDay(events: ArLeadershipEvent[], day: Date): number {
  const dayDate = parseISO(format(day, 'yyyy-MM-dd'))
  return events.filter((e) => !isAfter(dayDate, e.to) && !isBefore(dayDate, e.from)).length
}
